import React from "react";
import { GOVGR_TABS, GOVGR_TABS__LIST } from "../../conf/styles/GovGrTabs";

const GrGovTabs = ({ children }) => {
  return (
    <div className={GOVGR_TABS}>
      <ul className={GOVGR_TABS__LIST} role="tablist">
        {children}
      </ul>
    </div>
  );
};

export default GrGovTabs;
